import type { Formula } from "../../common/description";
import { rewriteFormula } from "./rewrite-formula";

export function getFormulaDepth(rootFormula: Formula): number {
    const [, depth] = rewriteFormula<number>(rootFormula, (f, subDepths) => {
        const d = subDepths.length > 0 ? Math.max(...subDepths) + 1 : 1;
        return [f, d];
    });
    return depth;
}

export function isFormulaDepthOK(f: Formula): boolean {
    return getFormulaDepth(f) <= 150;
}
